module.exports = __webpack_public_path__ + "static/media/privacy-notice.cb43502a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/forms/privacy-notice.pdf
// module id = 110
// module chunks = 0